import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { PurchaseOrderInvoiceViewModel } from "@tylertech/tyler-api-types";

import
{
    RequisitionSelectionDialogComponent,
    InvoiceDialogComponent, InvoiceDialogData,
    PoApprovalDialogComponent, PoApprovalDialogData
} from "../components";
import { BidQuotesDialogData, BidQuotesDialogComponent } from "../dialogs";
import { BidQuoteModel } from "../interfaces/bidQuote";

@Injectable()
export class PurchasingDialogsService
{
    private readonly matDialog = inject(MatDialog);


    showBidQuotes(
        bidQuotes: BidQuoteModel[],
        canEdit: boolean,
        multi: boolean = false,
        reqId?: string
    ): Promise<Array<BidQuoteModel>>
    {
        const dialogConfig: MatDialogConfig<BidQuotesDialogData> = {
            data: {
                bidQuotes,
                canEdit,
                multi,
                reqId
            }
        };
        const dialogRef = this.matDialog.open<BidQuotesDialogComponent, BidQuotesDialogData, Array<BidQuoteModel>>(BidQuotesDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }

    /**
     * @deprecated I think this has been replaced by a MetadataAction in the backend.
     * TODO - Confirm and Remove.
     */
    showInvoice(invoices: PurchaseOrderInvoiceViewModel[]): Promise<void>
    {
        const dialogConfig: MatDialogConfig<InvoiceDialogData> = {
            data: {
                invoices
            }
        };
        const dialogRef = this.matDialog.open<InvoiceDialogComponent, InvoiceDialogData, void>(InvoiceDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();

    }

    showRequisitionSelection(): Promise<void>
    {
        const dialogRef = this.matDialog.open<RequisitionSelectionDialogComponent>(RequisitionSelectionDialogComponent);
        return dialogRef.afterClosed().toPromise();
    }

    showPurchaseOrderApproval(date: Date): Promise<Date>
    {
        const dialogConfig: MatDialogConfig<PoApprovalDialogData> = {
            data: {
                reqDate: date
            }
        };
        const dialogRef = this.matDialog.open<PoApprovalDialogComponent, PoApprovalDialogData, Date>(PoApprovalDialogComponent, dialogConfig);

        return dialogRef.afterClosed().toPromise();
    }
}
